import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import BG1 from './assets/BG-1.png';
import BG2 from './assets/BG-2.png';
import BG3 from './assets/BG-3.png';
import BilgiYarismasiLogo from './assets/BilgiYarismasiLogo.png';
import CloseIcon from './assets/CloseIcon.png';
import CloseRedButton from './assets/CloseRedButton,.png';
import FalseIcon from './assets/False.png';
import InfoButton from './assets/InfoButton.png';
import LeaderboardButton from './assets/LeaderboardButton.png';
import GoBack from './assets/goBack.png';
import SkipIcon from './assets/play-next.svg';
import SoundOffButton from './assets/SoundOffButton.png';
import SoundOnButton from './assets/SoundOnButton.png';
import StartButton from './assets/StartButton.png';
import TrueIcon from './assets/True.png';
import AdSoundOffIcon from './assets/volume-down.svg';
import AdSoundOnIcon from './assets/volume-up.svg';
import ZCoin from './assets/coin.png';
import PoweredByZuzzuu from './assets/poweredByZuzzuu.png';
import BackgroundMusic from './music/CCI_TRIVIA_MUSIC.mp3';
import { ErrorContext } from "./index";

function App() {
  const oyunAcildiEventGitti = React.useRef(false);
  const backgroundMusicRef = React.useRef(null);
  const leaderboardBaseUrl = "https://zuzzuu.com/ldrbrd_cci_ksaMz2dZbLcP5vS3p8JufRmYQeCwHh";
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [userID, setUserID] = useState('');
  const baseUrl = queryParams.get("baseUrl") || "https://trivia.api.zuzzuu.com";
  const API_REFRESH_TOKEN_ENDPOINT = "https://api.cokecrush.cci.zuzzuu.com/refresh_token/";
  const gameAdsUrl = "https://api.cokecrush.cci.zuzzuu.com";
  const adFetchUrl = "https://api.cokecrush.cci.zuzzuu.com/game-ads/cci-bilgi-yarismasi/";

  const { errorMessage, setErrorMessage } = useContext(ErrorContext);

  const [screen, setScreen] = useState("lobby");
  const [infoOpen, setInfoOpen] = useState(false);
  const [leaderboardOpen, setLeaderboardOpen] = useState(false);
  const [leaderboardUrl, setLeaderboardUrl] = useState("");
  const [soundOpen, setSoundOpen] = useState(true);
  const [triviaId, setTriviaId] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const [isTokenInvalid, setIsTokenInvalid] = useState(false);
  const [accessToken, setAccessToken] = useState(token || "");
  const [sessionId, setSessionId] = useState(() => {
    const existing = localStorage.getItem("trivia_session_id");
    if (existing) return existing;
    const created = generateSessionId();
    localStorage.setItem("trivia_session_id", created);
    return created;
  });
  function goBack() {
    // Yeni token ile gamecenter'a yönlendir
    const currentTokenFromUrl = queryParams.get("token");
    const tokenToUse = accessToken || currentTokenFromUrl;
    if (tokenToUse) {
      window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=${tokenToUse}`;
    } else {
      window.history.back();
    }
  }
  const openLeaderboard = () => {
    if (!accessToken) return;
    setLeaderboardUrl(`${leaderboardBaseUrl}/?user_id=${userID}&token=${accessToken}&game_name=bilgi_yarismasi`);
    setLeaderboardOpen(true);
  };

  async function fetchWithRefresh(url, options, runtime, retry = true) {
    try {
      // Geçersiz token durumunda istek yapma
      if (isTokenInvalid) {
        throw new Error('Geçersiz Token');
      }

      const response = await fetch(url, options);
      // 401 veya 403 hatalarında "Geçersiz Token" mesajı göster (otomatik refresh devre dışı)
      if (response.status === 401 || response.status === 403) {
        setErrorMessage("Geçersiz Token");
        setIsTokenInvalid(true);
        if (response.status === 403) {
          // 403 durumunda 3 sn sonra gamecenter'a yönlendir
          const originalToken = queryParams.get("token");
          setTimeout(() => {
            if (originalToken) {
              window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=${originalToken}`;
            } else {
              window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=`;
            }
          }, 3000);
        }
        throw new Error('Geçersiz Token');
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Yalnızca uygulama açılışında bir kez refresh yap
  const didRunInitialRefreshRef = React.useRef(false);
  const isRefreshingRef = React.useRef(false);
  const [isInitialRefreshDone, setIsInitialRefreshDone] = useState(!token);

  async function refreshAccessToken(runtime) {
    try {
      // Tekilleştirme: Aynı anda/tekrar refresh'i engelle
      if (isRefreshingRef.current) {
        return runtime.globalVars.Token;
      }
      isRefreshingRef.current = true;

      const accessTokenCurrent = runtime.globalVars.Token;
      const url = `${API_REFRESH_TOKEN_ENDPOINT}?access_token=${accessTokenCurrent}`
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-store, no-cache, must-revalidate",
          "Pragma": "no-cache",
        },
        cache: "no-store",
      });

      // 401 veya 403 hatalarında "Geçersiz Token" mesajı göster
      if (response.status === 401 || response.status === 403) {
        setErrorMessage("Geçersiz Token");
        setIsTokenInvalid(true);
        if (response.status === 403) {
          // 403 durumunda 3 sn sonra gamecenter'a yönlendir
          const originalToken = queryParams.get("token");
          setTimeout(() => {
            if (originalToken) {
              window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=${originalToken}`;
            } else {
              window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=`;
            }
          }, 3000);
        }
        throw new Error('Geçersiz Token');
      }

      if (!response.ok) {
        throw new Error('Token refresh is not success.');
      }

      // Yanıt JSON ya da düz metin olabilir; ikisini de destekle
      let newAccessToken = null;
      const contentType = (response.headers.get("content-type") || "").toLowerCase();
      try {
        if (contentType.includes("application/json")) {
          const result = await response.json();
          newAccessToken = result?.access_token || result?.token || (typeof result === 'string' ? result : null);
        } else {
          const text = (await response.text())?.trim();
          if (text) newAccessToken = text.replace(/^\"|\"$/g, "");
        }
      } catch (e) {
        const text = (await response.text().catch(() => ""))?.trim();
        if (text) newAccessToken = text.replace(/^\"|\"$/g, "");
      }

      // Eğer yeni token dönmezse hata ver
      if (!newAccessToken) {
        setErrorMessage("Geçersiz Token");
        setIsTokenInvalid(true);
        throw new Error('Geçersiz Token');
      }

      // Yeni access token'ı global değişkenlere ve state'e set et
      runtime.globalVars.Token = newAccessToken;
      setAccessToken(newAccessToken);
      setIsTokenInvalid(false);

      return newAccessToken;

    } catch (error) {
      console.error("Token yenileme sırasında hata:", error);
      throw error;
    } finally {
      isRefreshingRef.current = false;
    }
  }

  function generateSessionId(length = 32) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  useEffect(() => {
    if (!token && !errorMessage) {
      setErrorMessage("Geçersiz oturum");
      // Removed navigation to error page; error state will be shown via context.
    }
  }, [token, errorMessage, setErrorMessage]);

  // App açılır açılmaz refresh token isteği yap (yalnızca bir kez)
  useEffect(() => {
    if (!token || isTokenInvalid) {
      setIsInitialRefreshDone(true);
      return;
    }
    if (didRunInitialRefreshRef.current) return;
    didRunInitialRefreshRef.current = true;

    const refreshTokenOnStart = async () => {
      try {
        const newToken = await refreshAccessToken({ globalVars: { Token: token } });
        console.log("Token başarıyla yenilendi:", newToken);
        // refresh başarılı ise olası önceki hatayı temizle
        setErrorMessage(null);
      } catch (error) {
        console.error("Token yenileme başarısız:", error);
        // Hata zaten refreshAccessToken içinde handle ediliyor
      } finally {
        setIsInitialRefreshDone(true);
      }
    };

    refreshTokenOnStart();
    // deliberately empty deps to run only once in this session
  }, []);

  // Lobby açıldığında trivia aktifliği ve token kontrolü (ilk kontrol)
  useEffect(() => {
    if (!token || isTokenInvalid) return;
    if (token && !isInitialRefreshDone) return;
    if (didRunCheckRef.current) return;
    didRunCheckRef.current = true;

    setIsChecking(true);
    fetchWithRefresh(`${baseUrl}/trivia-progress/check`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }, { globalVars: { Token: accessToken } })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          let errorMsg = errorData.detail || errorData.message || "Bir hata oluştu";
          setErrorMessage(errorMsg);
          setTriviaId(null);
          return;
        }
        const data = await response.json();
        if (data?.has_active_trivia === true) {
          if (data?.trivia_id) setTriviaId(data.trivia_id); else setTriviaId(null);
          if (data?.user_id) setUserID(data.user_id);
          setErrorMessage(null);
          return;
        }
        setErrorMessage("Aktif trivia bulunamadı");
        setTriviaId(null);
      })
      .catch(() => {
        setErrorMessage("Sunucuya ulaşılamadı");
        setTriviaId(null);
      })
      .finally(() => {
        setIsChecking(false);
      });
  }, [token, baseUrl, isInitialRefreshDone, isTokenInvalid, accessToken]);

  // Lobby ilk açıldığında oyun_acildi eventini gönder
  useEffect(() => {
    if (
      token &&
      screen === "lobby" &&
      triviaId &&
      !oyunAcildiEventGitti.current
    ) {
      sendTriviaEvent({
        event_name: "oyun_acildi",
        trivia_id: triviaId,
        token,
        baseUrl,
        session_id: sessionId,
      });
      oyunAcildiEventGitti.current = true;
    }
  }, [token, screen, baseUrl, triviaId, sessionId]);

  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(true);
  const [timerExpired, setTimerExpired] = useState(false);
  const [correctAnswerId, setCorrectAnswerId] = useState(null);
  const [isCorrectAnswer, setIsCorrectAnswer] = useState(null);
  const [isAnswerLoading, setIsAnswerLoading] = useState(false);
  const [paused, setPaused] = useState(false);
  const didRunCheckRef = React.useRef(false);
  const didRunAdsRef = React.useRef(false);
  const [adsStart, setAdsStart] = useState([]);
  const [adsInGame, setAdsInGame] = useState([]);
  const [adsEnd, setAdsEnd] = useState([]);
  const [currentAd, setCurrentAd] = useState(null);
  const [adModalOpen, setAdModalOpen] = useState(false);
  const [adClosable, setAdClosable] = useState(false);
  const [adMuted, setAdMuted] = useState(true);
  const adVideoRef = React.useRef(null);
  // AD TIMER STATES
  const [adTimer, setAdTimer] = useState(0);
  const [adTotalTime, setAdTotalTime] = useState(0);
  // Forcing rerender for video progress bar (deprecated, replaced with percent state)
  // const [, setVideoProgress] = useState(0);
  // Track percent progress for ad video progress bar
  const [videoProgressPercent, setVideoProgressPercent] = useState(0);
  // Track if we need to fetch next question after ad closes
  const [pendingNextQuestion, setPendingNextQuestion] = useState(false);

  // Update video progress bar as video plays
  useEffect(() => {
    const video = adVideoRef.current;
    if (!video) return;

    const updateProgress = () => {
      if (video && video.duration && !video.paused) {
        setVideoProgressPercent((video.currentTime / video.duration) * 100);
        setAdTimer(Math.floor(video.currentTime));
      }
    };

    video.addEventListener("timeupdate", updateProgress);
    return () => {
      video.removeEventListener("timeupdate", updateProgress);
    };
  }, [currentAd]);

  // Unmute mandatory video ads after 0.1s if allowed
  useEffect(() => {
    const video = adVideoRef.current;
    if (
      video &&
      currentAd?.media_type === "video" &&
      currentAd.mandatory
    ) {
      const timer = setTimeout(() => {
        try {
          video.muted = false;
          video.volume = 1;
          setAdMuted(false);
        } catch (e) {
          // Tarayıcı engellerse sessiz geç
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [currentAd]);

  // Reset video progress percent when a new video ad starts
  useEffect(() => {
    if (currentAd?.media_type === "video") {
      setVideoProgressPercent(0);
    }
  }, [currentAd]);

  // Restart mandatory video ads if paused
  useEffect(() => {
    const video = adVideoRef.current;
    if (!video || currentAd?.media_type !== "video" || !currentAd.mandatory) return;

    const handlePause = () => {
      if (!video.ended) {
        video.play().catch(() => { });
      }
    };

    video.addEventListener("pause", handlePause);
    return () => {
      video.removeEventListener("pause", handlePause);
    };
  }, [currentAd]);



  useEffect(() => {
    // İlk açılışta 3 pozisyonda reklamları çek
    if (!token || isTokenInvalid) return;
    if (token && !isInitialRefreshDone) return;

    // Kalıcı oturum kilidi: aynı oturumda sadece bir kez çalıştır
    const adsLockKey = 'cci_trivia_ads_done';
    if (sessionStorage.getItem(adsLockKey) === '1') return;
    if (didRunAdsRef.current) return;
    didRunAdsRef.current = true;
    sessionStorage.setItem(adsLockKey, '1');

    const fetchAds = async (position, setter, current) => {
      try {
        const res = await fetchWithRefresh(
          `${adFetchUrl}?position=${position}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          },
          { globalVars: { Token: accessToken } }
        );
        const data = await res.json();
        const list = data?.ads || [];
        // Redundant state güncellemeyi önle
        if (!Array.isArray(current) || current.length !== list.length) {
          setter(list);
        }
      } catch {
        if (Array.isArray(current) && current.length === 0) return;
        setter([]);
      }
    };
    fetchAds("oyun_basinda", setAdsStart, adsStart);
    fetchAds("oyun_esnasinda", setAdsInGame, adsInGame);
    fetchAds("oyun_sonunda", setAdsEnd, adsEnd);
  }, [token, isInitialRefreshDone, isTokenInvalid, accessToken, adFetchUrl]);


  const showAd = (ad, position, index) => {
    setCurrentAd({ ...ad, position, index });
    // Reklam gösterildiğinde logla
    if (ad?.ad_id) {
      fetchWithRefresh(
        `${gameAdsUrl}/game-ads/log?ad_id=${ad.ad_id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        },
        { globalVars: { Token: accessToken } }
      ).catch(() => { /* Sessiz geç */ });
    }
    setAdModalOpen(true);
    let total = 0;
    if (ad.media_type === "image") {
      total = ad.mandatory ? 5 : 0; // sn cinsinden
    } else if (ad.media_type === "video") {
      total = ad.mandatory ? 0 : 5;
    }
    setAdTotalTime(total);
    setAdTimer(0);

    // Opsiyonel görseller için süre yok, direkt geçilebilir
    if (ad.media_type === "image" && !ad.mandatory) {
      setAdClosable(true);
    } else {
      setAdClosable(false);
    }
    if (ad.media_type === "video") setAdMuted(true);
  };
  // AD SYSTEM TIMER EFFECT
  useEffect(() => {
    if (!adModalOpen || adTotalTime === 0) return;
    if (adTimer >= adTotalTime) {
      setAdClosable(true);
      return;
    }
    const interval = setInterval(() => {
      setAdTimer(prev => {
        if (prev + 1 >= adTotalTime) {
          clearInterval(interval);
          setAdClosable(true);
          return adTotalTime;
        }
        return prev + 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [adModalOpen, adTotalTime, adTimer]);

  const showNextAd = () => {
    if (!currentAd) return;
    let adsList = [];
    if (currentAd.position === "oyun_basinda") adsList = adsStart;
    else if (currentAd.position === "oyun_esnasinda") adsList = adsInGame;
    else if (currentAd.position === "oyun_sonunda") adsList = adsEnd;
    const nextIndex = (currentAd.index ?? 0) + 1;
    if (adsList.length > nextIndex) {
      showAd(adsList[nextIndex], currentAd.position, nextIndex);
    } else {
      setAdModalOpen(false);
      setCurrentAd(null);
      // Eğer oyun başında reklam ise, quiz ekranına geçişi burada yap
      if (currentAd.position === "oyun_basinda") {
        setScreen("quiz");
      }
      // Eğer oyun esnasında reklamlar bittiyse ve bekleyen soru varsa, sonraki soruyu çek
      if (currentAd.position === "oyun_esnasinda" && pendingNextQuestion) {
        fetchNextQuestion();
      }
    }
  };
  // --- AD SYSTEM BİTİŞ ---

  // --- BACKGROUND MUSIC SETUP ---
  const [musicInitialized, setMusicInitialized] = useState(false);

  useEffect(() => {
    // Müzik dosyasını oluştur ve ayarla
    if (!backgroundMusicRef.current) {
      backgroundMusicRef.current = new Audio(BackgroundMusic);
      backgroundMusicRef.current.loop = true;
      backgroundMusicRef.current.volume = 0.3; // Ses seviyesini ayarla
    }

    const music = backgroundMusicRef.current;

    // Component unmount olduğunda müziği temizle
    return () => {
      if (music) {
        music.pause();
        music.currentTime = 0;
      }
    };
  }, []);

  // Müziği başlatma fonksiyonu
  const initializeMusic = async () => {
    if (backgroundMusicRef.current && soundOpen && !musicInitialized) {
      try {
        await backgroundMusicRef.current.play();
        setMusicInitialized(true);
        console.log("Müzik başarıyla başlatıldı");
      } catch (error) {
        console.log("Müzik başlatılamadı:", error);
      }
    }
  };

  // Sound button kontrolü
  useEffect(() => {
    if (backgroundMusicRef.current && musicInitialized) {
      if (soundOpen && !adModalOpen) {
        backgroundMusicRef.current.play().catch(() => { });
      } else {
        backgroundMusicRef.current.pause();
      }
    }
  }, [soundOpen, adModalOpen, musicInitialized]);

  // Reklam durumunda müziği kontrol et
  useEffect(() => {
    if (backgroundMusicRef.current && musicInitialized) {
      if (adModalOpen) {
        backgroundMusicRef.current.pause();
      } else if (soundOpen) {
        backgroundMusicRef.current.play().catch(() => { });
      }
    }
  }, [adModalOpen, soundOpen, musicInitialized]);

  // Configurable values (can be changed through panels)
  const [totalTime, setTotalTime] = useState(60);
  const timeoutPoints = 0;         // Points awarded when time runs out

  // Fetch questions from API
  useEffect(() => {
    if (screen !== "quiz") return;
    if (!token || isTokenInvalid) return;
    if (token && !isInitialRefreshDone) return;

    fetchWithRefresh(`${baseUrl}/trivia-progress/start`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }, { globalVars: { Token: accessToken } })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.detail || "Sunucu hatası");
          error.response = response;
          throw error;
        }
        return response.json();
      })
      .then(data => {
        // PATCH: if completed, show result and set score, loading, etc.
        if (data.completed === true) {
          setScore(data.current_score || 0);
          setShowResult(true);
          setLoading(false);
          setCorrectAnswerId(null);
          setAnswered(false);        // ekle
          setSelectedAnswer(null);   // ekle
          setQuestions([]);          // ekle
          return;
        }

        if (!data || !data.question || !data.answers) {
          setErrorMessage("Bir hata oluştu");
          return;
        }

        const tpq = Number(data.time_per_question);
        setTotalTime(Number.isFinite(tpq) && tpq > 0 ? Math.ceil(tpq) : 60);

        const formattedQuestion = {
          id: data.question_id,
          question: data.question,
          options: data.answers,
          correct_answer: data.correct_answer_id || null,
          question_number: data.question_number,
        };

        setQuestions([formattedQuestion]);
        setCurrentQuestionIndex(0);
        setScore(data.current_score || 0);
        setLoading(false);
        setCorrectAnswerId(null);
      })
      .catch(async error => {
        console.error("Error fetching questions from API:", error);
        let errorMsg = "Bir hata oluştu";

        // 401 veya 403 hatalarında "Geçersiz Token" mesajı göster
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          errorMsg = "Geçersiz Token";
        } else if (error instanceof Error && error.message && error.message !== "Failed to fetch") {
          errorMsg = error.message;
        } else if (error?.response) {
          try {
            const res = await error.response.json();
            errorMsg = res?.message || "Bir hata oluştu";
          } catch (_) {
            // Ignore JSON parse error
          }
        }

        setErrorMessage(errorMsg);
      });
  }, [screen, token, baseUrl, isTokenInvalid, accessToken, isInitialRefreshDone]);

  const currentQuestion = questions.length > 0 ? questions[currentQuestionIndex] : null;

  // Timer effect
  useEffect(() => {
    if (screen !== "quiz") return;
    // Sayaç sadece reklam modalı açık DEĞİLSE ve paused DEĞİLSE çalışmalı
    if (!loading && questions.length > 0 && !answered && !showResult && !adModalOpen && !paused) {
      const interval = setInterval(() => {
        if (timer < totalTime) {
          setTimer(timer + 1);
        } else {
          clearInterval(interval);
          setTimerExpired(true);
          setAnswered(true);
          setIsAnswerLoading(false);
          setShowResult(true);
          if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
            showAd(adsEnd[0], "oyun_sonunda", 0);
          }
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [screen, timer, answered, showResult, loading, questions.length, baseUrl, currentQuestion, token, score, setErrorMessage, adModalOpen, paused, totalTime]);

  // Eğer errorMessage varsa, tüm ekranı sadece hata mesajıyla göster (return ile):
  if (errorMessage) {
    return (
      <div className="quiz-container">
        <div className="loading">{errorMessage}</div>
      </div>
    );
  }

  // Lobby ekranı için check isteği sırasında yükleniyor göster
  if (screen === "lobby" && isChecking) {
    return (
      <div className="quiz-container">
        <div className="loading">Yükleniyor...</div>
      </div>
    );
  }

  // If loading or no questions, show loading state
  if (screen === "quiz" && !showResult && (loading || questions.length === 0)) {
    return (
      <div className="quiz-container">
        <div className="loading">Sorular yükleniyor...</div>
      </div>
    );
  }

  // Eğer initial refresh bitmeden ve token varken, UI'yi blokla
  if (token && !isInitialRefreshDone) {
    return (
      <div className="quiz-container" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", width: "100%" }}>
        <div className="loading" style={{ color: "#d40000" }}>Yükleniyor...</div>
      </div>
    );
  }

  // Trivia event endpointine event gönderimi
  const sendTriviaEvent = async ({ event_name, trivia_id, token, baseUrl, session_id }) => {
    try {
      await fetchWithRefresh(
        `${baseUrl}/trivia/event`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
          },
          body: JSON.stringify({
            trivia_id,
            event_name,
            session_id
          })
        },
        { globalVars: { Token: accessToken } }
      );
    } catch (e) {
      // Sessiz geç
    }
  };

  // Sonraki soruyu çekmek için yardımcı fonksiyon
  const fetchNextQuestion = () => {
    fetchWithRefresh(
      `${baseUrl}/trivia-progress/start`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      },
      { globalVars: { Token: accessToken } }
    )
      .then(res => res.json())
      .then(next => {
        setScore(next.current_score || score);
        const nextTpq = Number(next.time_per_question);
        setTotalTime(Number.isFinite(nextTpq) && nextTpq > 0 ? Math.ceil(nextTpq) : 60);
        const nextQuestion = {
          id: next.question_id,
          question: next.question,
          options: next.answers,
          correct_answer: null,
          question_number: next.question_number,
          current_score: next.current_score || score,
        };
        setQuestions([nextQuestion]);
        setCurrentQuestionIndex(0);
        setAnswered(false);
        setSelectedAnswer(null);
        setTimer(0);
        setTimerExpired(false);
        setLoading(false);
        setCorrectAnswerId(null);
        setIsCorrectAnswer(null);
        setPendingNextQuestion(false);
      })
      .catch(err => {
        console.error("Error fetching next question:", err);
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setErrorMessage("Geçersiz Token");
        } else {
          setErrorMessage("Bir hata oluştu");
        }
        setPendingNextQuestion(false);
      });
  };

  const handleAnswerSelect = (answerId) => {
    setSelectedAnswer(answerId);
    setAnswered(true);
    setIsAnswerLoading(true);

    const currentQuestionId = currentQuestion.id;
    const selectedAnswerId = answerId;

    fetchWithRefresh(
      `${baseUrl}/trivia-progress/answer?question_id=${currentQuestionId}&selected_answer_id=${selectedAnswerId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      },
      { globalVars: { Token: accessToken } }
    )
      .then(res => res.json())
      .then(data => {
        setScore(data.current_score || score);
        setIsCorrectAnswer(data.correct);

        const updatedQuestion = {
          ...currentQuestion,
          correct_answer: data.correct_answer_id || null,
          // Removed current_score as per instructions
        };
        setQuestions([updatedQuestion]);
        setCorrectAnswerId(data.correct_answer_id || null);
        if (!data.correct && data.correct_answer_id) {
          setCorrectAnswerId(data.correct_answer_id);
        }
        setIsAnswerLoading(false);

        setTimeout(() => {
          if (!data.completed) {
            // 5. soru sonunda reklam göster
            const currentQuestionNumber = currentQuestion?.question_number;
            if (currentQuestionNumber === 5 && adsInGame.length > 0 && !adModalOpen && !currentAd) {
              // Reklam gösterilecek, sonraki soru isteğini bekle
              setPendingNextQuestion(true);
              showAd(adsInGame[0], "oyun_esnasinda", 0);
            } else {
              // Normal akış: hemen sonraki soruyu çek
              fetchNextQuestion();
            }
          } else {
            setShowResult(true);
            if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
              showAd(adsEnd[0], "oyun_sonunda", 0);
            }
          }
        }, 2000);
      })
      .catch(err => {
        console.error("Answer submission error:", err);
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setErrorMessage("Geçersiz Token");
        } else {
          setErrorMessage("Bir hata oluştu");
        }
        setIsAnswerLoading(false);
      });
  };

  const handleNextQuestion = () => {
    setAnswered(false);
    setSelectedAnswer(null);
    setTimer(0);
    setTimerExpired(false);

    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(prevIndex => prevIndex + 1);
    } else {
      setShowResult(true);
    }
  };


  const getButtonStyle = (optionId) => {
    if (!answered) return "";
    if (optionId === selectedAnswer) {
      if (isAnswerLoading) return "load";
      return isCorrectAnswer ? "correct" : "incorrect";
    }
    if (!isCorrectAnswer && optionId === correctAnswerId) {
      return "correct";
    }
    return "";
  };

  // Calculate the circle progress (reversed)
  const calculateProgressCircle = () => {
    // Calculate percentage remaining (starts at 100%, goes to 0%)
    const remainingPercentage = 100 - (timer / totalTime) * 100;
    const circumference = 2 * Math.PI * 24; // radius is 24px

    return {
      strokeDasharray: `${circumference}`,
      strokeDashoffset: `${circumference - (remainingPercentage / 100) * circumference}`,
    };
  };

  const progressStyle = calculateProgressCircle();


  // Determine background based on question content
  let currentBackground = BG1; // Default background for normal questions
  if (currentQuestion && typeof currentQuestion.question === "string") {
    const lowerText = currentQuestion.question.toLowerCase();
    if (lowerText.includes("sprite")) {
      currentBackground = BG3;         // Sprite‑related question
    } else if (lowerText.includes("fanta")) {
      currentBackground = BG2;         // Fanta‑related question
    }
  }



  return (
    <div className="quiz-container" style={{ backgroundImage: `url(${currentBackground})` }}>
      {leaderboardOpen && (
        <div className="modal-overlay" onClick={() => setLeaderboardOpen(false)}>
          <div className="modal-content leaderboard-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setLeaderboardOpen(false)}>
              <img src={CloseRedButton} alt="Kapat" className="modal-close-img" />
            </button>
            <iframe
              src={leaderboardUrl}
              title="Leaderboard"
              frameBorder="0"
              className="leaderboard-iframe"
            />
          </div>
        </div>
      )}
      {adModalOpen && currentAd && (
        <div className="ad-modal-overlay">
          <div className="ad-modal-content" style={{ position: "relative" }}>
            {/* AD SOUND ICON BUTTON */}
            {currentAd.media_type === "video" && (
              <button
                className="ad-sound-icon-btn"
                onClick={() => {
                  setAdMuted(m => {
                    const newMuted = !m;
                    if (adVideoRef.current) {
                      adVideoRef.current.muted = newMuted;
                      if (!newMuted) adVideoRef.current.volume = 1;
                    }
                    return newMuted;
                  });
                }}
              >
                <img
                  src={adMuted ? AdSoundOffIcon : AdSoundOnIcon}
                  alt={adMuted ? "Sesi Aç" : "Sesi Kapat"}
                  className="ad-sound-icon-img"
                />
                <p>{adMuted ? "Sesi Aç" : "Sesi Kapat"}</p>
              </button>
            )}
            <div className="ad-modal-header">
              {adTotalTime > 0 && !adClosable && (
                <div className="ad-circular-timer">
                  <svg className="ad-timer-svg" viewBox="0 0 56 56">
                    <circle className="ad-timer-background" cx="28" cy="28" r="24" />
                    <circle
                      className="ad-timer-progress"
                      cx="28"
                      cy="28"
                      r="24"
                      style={{
                        strokeDasharray: `${2 * Math.PI * 24}`,
                        strokeDashoffset: `${2 * Math.PI * 24 - ((adTotalTime === 0 ? 0 : 100 - (adTimer / adTotalTime) * 100) / 100) * 2 * Math.PI * 24}`,
                      }}
                    />
                  </svg>
                  <span className="ad-timer-text">{adTotalTime - adTimer}</span>
                </div>
              )}
              {adClosable && (
                <button
                  className="ad-close-icon-btn"
                  style={{ position: "relative" }}
                  onClick={() => {
                    setAdModalOpen(false);
                    setCurrentAd(null);
                    showNextAd();
                  }}
                >
                  <img src={SkipIcon} alt="Kapat" className="ad-close-icon-img" />
                  <p>Reklamı Geç</p>
                </button>
              )}
            </div>
            {currentAd.media_type === "image" ? (
              <img src={currentAd.media_url} alt="Ad" className="ad-media" />
            ) : (
              <>
                <video
                  ref={adVideoRef}
                  src={currentAd.media_url}
                  controls={false}
                  autoPlay
                  loop
                  muted={adMuted}
                  playsInline
                  webkit-playsinline="true"
                  onEnded={() => {
                    if (currentAd.mandatory) setAdClosable(true);
                  }}
                  className="ad-media"
                  onLoadedMetadata={e => {
                    // Zorunlu videoda sayaç videonun uzunluğu kadar olacak
                    if (currentAd.media_type === "video" && currentAd.mandatory) {
                      setAdTotalTime(Math.ceil(e.target.duration));
                      setAdTimer(0);
                    }
                  }}
                />
                <div
                  className="ad-video-progress-bar"
                  style={{
                    width: `${videoProgressPercent}%`
                  }}
                />
              </>
            )}
            <div className="ad-index-info">
              {(() => {
                let totalAds = 0;
                if (currentAd.position === "oyun_basinda") totalAds = adsStart.length;
                else if (currentAd.position === "oyun_esnasinda") totalAds = adsInGame.length;
                else if (currentAd.position === "oyun_sonunda") totalAds = adsEnd.length;
                const indexText = `${(currentAd.index ?? 0) + 1} / ${totalAds}`;
                const durationText =
                  currentAd.media_type === "video" && adVideoRef.current
                    ? (() => {
                      const video = adVideoRef.current;
                      const remaining = Math.floor((video.duration || 0) - video.currentTime);
                      const minutes = Math.floor(remaining / 60);
                      const seconds = remaining % 60;
                      return ` • ${minutes}:${seconds.toString().padStart(2, "0")}`;
                    })()
                    : "";
                return `${indexText}${durationText}`;
              })()}
            </div>
          </div>
        </div>
      )}
      {infoOpen && (
        <div className="modal-overlay" onClick={() => setInfoOpen(false)}>
          <div
            className="modal-content modal-border-card"
            onClick={e => e.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setInfoOpen(false)}
            >
              <img src={CloseRedButton} alt="Kapat" className="modal-close-img" />
            </button>
            <div
              className="modal-inner-content"
            >
              <h2 className="modal-title">Nasıl Oynanır</h2>
              <ul className="modal-info-list">
                <li>Soruları doğru cevapla, puanları kazan, her doğru cevap 10 puan!</li>
                <li>Süren sınırlı, hızlı düşün!</li>
              </ul>
              <div className="powered-by-container">
                <img src={PoweredByZuzzuu} alt="Powered by Zuzzuu" className="powered-by-logo" />
              </div>
            </div>
          </div>
        </div>
      )}
      {screen === "lobby" ? (
        <div className="lobby-container">
          <div className="buttons-container">
            <button className="info-button" onClick={() => {
              if (!musicInitialized) initializeMusic();
              goBack(true);
            }}>
              <img src={GoBack} alt="Bilgi" />
            </button>
            <button className="sound-button" onClick={() => {
              setSoundOpen(prev => {
                const newSoundOpen = !prev;
                if (newSoundOpen && !musicInitialized) {
                  initializeMusic();
                }
                return newSoundOpen;
              });
            }}>
              {soundOpen ? (
                <img src={SoundOnButton} alt="Ses Açık" />
              ) : (
                <img src={SoundOffButton} alt="Ses Kapalı" />
              )}
            </button>
          </div>
          <div className="buttons-container">
            <button className="leaderboard-button" onClick={() => {
              if (!musicInitialized) initializeMusic();
              openLeaderboard();
            }}>
              <img src={LeaderboardButton} alt="Bilgi" />
            </button>
          </div>
          <img src={BilgiYarismasiLogo} alt="Bilgi Yarışması Logo" className="home-logo" />
          <button
            className="start-button"
            onClick={async () => {
              // Initial refresh tamamlanmadan API çağrısı yapma
              if (token && !isInitialRefreshDone) {
                setLoading(true);
                return;
              }
              // Müziği başlat
              if (!musicInitialized) await initializeMusic();

              // Reset all relevant gameplay state to ensure clean start before starting quiz
              setScore(0);
              setShowResult(false);
              setAnswered(false);
              setSelectedAnswer(null);
              setQuestions([]);
              setTimer(0);
              setTimerExpired(false);
              setLoading(true);
              setCorrectAnswerId(null);
              setIsCorrectAnswer(null);
              setIsAnswerLoading(false);
              // Eğer başta reklam varsa önce reklamı göster, quiz ekranına reklam bitince geçilecek
              if (adsStart.length > 0) {
                showAd(adsStart[0], "oyun_basinda", 0);
                return; // reklam bitince screen değişimi yapılacak
              }
              try {
                const response = await fetchWithRefresh(
                  `${baseUrl}/trivia-progress/start`,
                  {
                    headers: {
                      Authorization: `Bearer ${accessToken}`
                    }
                  },
                  { globalVars: { Token: accessToken } }
                );
                const data = await response.json();
                if (data.completed === true) {
                  setScore(data.current_score || 0);
                  setShowResult(true);
                  // State already reset above
                  setScreen("quiz");
                  return;
                }
                sendTriviaEvent({ event_name: "oyun_basladi", trivia_id: triviaId, token, baseUrl, session_id: sessionId });
                setScreen("quiz");
              } catch {
                setErrorMessage("Başlatılamadı, tekrar deneyin.");
              }
            }}>
            <img src={StartButton} alt="Başla" />
          </button>
          <button className="info-button" onClick={() => {
            if (!musicInitialized) initializeMusic();
            setInfoOpen(true);
          }}>
            <img src={InfoButton} alt="Bilgi" />
          </button>
          <div className="version-info">v1.0.0.2</div>
        </div>
      ) : (
        <>
          {/* Aşağıdaki mevcut quiz kodunun tamamını buraya al */}
          {showResult ? (
            <div className="modal-overlay" onClick={() => {
              if (!musicInitialized) initializeMusic();
              setShowResult(false);
              setScreen("lobby");
              if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
                showAd(adsEnd[0], "oyun_sonunda", 0);
              }
            }}>
              <div
                className="modal-content modal-border-card"
                onClick={e => e.stopPropagation()}
              >
                <button
                  className="modal-close"
                  onClick={() => {
                    if (!musicInitialized) initializeMusic();
                    setShowResult(false);
                    setScreen("lobby");
                    if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
                      showAd(adsEnd[0], "oyun_sonunda", 0);
                    }
                  }}
                >
                  <img src={CloseRedButton} alt="Kapat" className="modal-close-img" />
                </button>
                <div className="modal-inner-content">
                  <h2 className="modal-title">{score === 0 ? "ÜZGÜNÜZ ☹️" : "SORULARI TAMAMLADINIZ 😊"}</h2>
                  <p className="score-text">Puanınız</p>
                  <p className="score-result">{score}</p>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="header-container">
                <div className="header-buttons">
                  <button className="exit-button" onClick={() => {
                    if (!musicInitialized) initializeMusic();
                    setPaused(false);
                    setShowResult(false);
                    setScreen("lobby");
                    if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
                      showAd(adsEnd[0], "oyun_sonunda", 0);
                    }
                  }}>
                    <img src={GoBack} alt="Ana Sayfa" />
                  </button>
                </div>
                {!timerExpired && (
                  <div className="timer-container">
                    <div className="circular-timer">
                      <svg className="timer-svg" viewBox="0 0 56 56">
                        <circle className="timer-background" cx="28" cy="28" r="24" />
                        <circle
                          className="timer-progress"
                          cx="28" cy="28" r="24"
                          style={progressStyle}
                        />
                      </svg>
                      <div className="timer-text">{String(totalTime - timer).padStart(2, '0')}</div>
                    </div>
                  </div>
                )}
                <div className="score-container">
                  <div className="score">
                    <img src={ZCoin} alt="ZCoin" className="coin-icon" />
                    <p>{score}</p>
                  </div>
                </div>
              </div>
              <div className="content-container">
                <div className="question-content">
                  <div className="question-number">{currentQuestion?.question_number}. SORU</div>
                  <h2 className="question-text">{currentQuestion?.question}</h2>
                </div>
                <div className="options-container">
                  {currentQuestion?.options?.map((option, index) => (
                    <button
                      key={index}
                      onClick={() => !answered && handleAnswerSelect(option.id)}
                      className={`option-button ${getButtonStyle(option.id)}`}
                      disabled={answered}
                    >
                      <p className="option-text">
                        {option.answer}
                      </p>
                      {answered && (
                        <>
                          {selectedAnswer === option.id && (
                            <img
                              src={isCorrectAnswer ? TrueIcon : FalseIcon}
                              alt={isCorrectAnswer ? "Doğru" : "Yanlış"}
                              className="answer-icon"
                            />
                          )}
                          {!isCorrectAnswer && option.id === correctAnswerId && option.id !== selectedAnswer && (
                            <img
                              src={TrueIcon}
                              alt="Doğru"
                              className="answer-icon"
                            />
                          )}
                        </>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}
          {paused && (
            <div className="modal-overlay" onClick={() => { }}>
              <div className="modal-content modal-border-card" onClick={e => e.stopPropagation()}>
                <div className="modal-inner-content">
                  <h2 className="modal-title">Duraklatıldı</h2>
                  <div className="pause-buttons">
                    <button
                      className="resume-button"
                      onClick={() => {
                        if (!musicInitialized) initializeMusic();
                        setPaused(false);
                      }}
                    >
                      <img src={StartButton} alt="Devam Et" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default App;